import TimerCuberos from './components/TimerCuberos'

function App() {
  return (
    <>
      <TimerCuberos />
    </>
  )
}

export default App
